import { defineStore } from "pinia";
import { ref } from "vue";
import { ofetch } from "ofetch";

export const useSettingsStore = defineStore("settings", () => {
  const settings = ref(null);

  async function loadSettings() {
    settings.value = await ofetch("/api/public/settings", {
      retryDelay: 600,
      retry: 5,
    });
    return settings.value;
  }

  return { settings, loadSettings };
});
